import axios from "axios";
export default {
    data() {
        return {
            client_session_id: null,
            loading: false
        }
    },
    created() {
        if(process.env.VUE_APP_URL_QUEUE_API !== 'disabled') {
            if(localStorage.client_session_id) {
                this.client_session_id = localStorage.client_session_id;
                this.registrarActividad()
            } else {
                this.iniciarAtividad()
            }

            setInterval(() => {
                this.registrarActividad()
            }, 45000)
        }
    },
    computed: {
        ruta() {
            return this.$route.fullPath;
        },
        url() {
            return window.location.hostname;
        }
    },
    watch : {
        ruta() {
            if(process.env.VUE_APP_URL_QUEUE_API !== 'disabled' && ! this.loading) {
                this.client_session_id = localStorage.client_session_id;
                this.registrarActividad();
            }
        },
    },
    methods: {
        registrarActividad() {
            var admin = this.isRutaAdmin();
            if(!admin){
                this.loading = true;
                axios.post(process.env.VUE_APP_URL_QUEUE_API + '/api/queue/clients/activity', {
                    url: this.url,
                    page: this.ruta,
                    id: this.client_session_id
                }).then(response => {
                    if(response.data.error) {
                        localStorage.client_session_id = null;
                        this.client_session_id = null;
                        this.iniciarAtividad()
                    } else {
                        if(response.data.waiting_room != null) {
                            this.redirect(response.data.session_id);
                        }
    
                        this.loading = false;
                    }
                })
            }
        },
        iniciarAtividad() {
            var admin = this.isRutaAdmin();
            if(!admin){
                this.loading = true;
                axios.post(process.env.VUE_APP_URL_QUEUE_API + '/api/queue/clients/new-client', {
                    url: this.url,
                    page: this.ruta
                }).then(response => {
                    this.client_session_id = response.data.client_id;
                    localStorage.client_session_id = this.client_session_id;
    
                    if(response.data.waiting_room != null) {
                        this.redirect(response.data.session_id);
                    }
    
                    this.loading = false;
                }).catch(error => {
                    if(!this.isRutaAdmin()  && this.client_session_id == null){
                        this.$router.push({name: 'front.queue', params: {redirect: false}});
                    }
                })
            }
        },
        redirect(session_id) {
            window.location.href = process.env.VUE_APP_SALA_ESPERA_URL + '/?client_id=' + session_id;
        },
        isRutaAdmin() {
            const currentPath = window.location.pathname;
            return currentPath.includes('admin') || currentPath.includes('reservas');
        },
    }
}